import { FC } from 'react';
import styles from './SegmentItem.module.css';
import type { SegmentItemProps } from './SegmentItem.types';
import { getClasses } from '@/_utils/classnames';
import { Icon } from '@/_components/Icon';

export const SegmentItem: FC<SegmentItemProps> = ({
  isActive,
  title,
  icon,
  onClick,
}) => {
  const segmentClasses: string = getClasses(styles.segmentItem, {
    [styles.segmentItemActive]: isActive,
  });

  return (
    <div
      className={segmentClasses}
      onClick={onClick}
      data-component="SegmentItem"
    >
      {icon ? <Icon name={icon} size={16} /> : title}
    </div>
  );
};
